import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  BoatOwnerSMSInfo,
  CharterDAO,
} from '../../../../core/services/dao/charterDAO';
import { UploadDAO } from '../../../../core/services/dao/uploadDAO';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { getUtcCharterDate } from '../../../../core/models/charter';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

import { PayoutDAO } from '../../../../core/services/dao/payoutDAO';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NoCaptainModalComponent } from '../../../shared/modals/no-captain/no-captian-modal.component';
import { CancelCharterChickenTestComponent } from '../../../shared/modals/cancel-charter-chicken-test/cancel-charter-chicken-test.component';
import { DialogsService } from '../../../../core/services/dialog.service';
import { ConstantMan } from '../../../../core/services/constantMan';
import { NumberFormatterService } from '../../../../core/services/number.formatter.service';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { VesselRateDAO } from '../../../../core/services/dao/vesselRateDAO';
import { BehaviorSubject, combineLatest, concat, Subscription } from 'rxjs';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { AppMessagingService } from '../../../../core/services/app-messaging.service';
import { Customer } from 'anchor-shared/lib/model/entity/customer';
import {
  CustomerDAO,
  CustomerPaymentMethod,
} from '../../../../core/services/dao/customerDAO';
import { CharterItinerary } from '../../../../core/models/interface/charters/charter-models';
import { ChickenTestDialogService } from '../../../shared/dialogs/chicken-test-dialog/chicken-test-dialog.service';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { MooringLocationDAO } from '../../../../core/services/dao/mooringLocationDAO';
import { Payment } from 'anchor-shared/lib/model/entity/payment';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { CaptainManageDetailsDAO } from '../../../../core/services/dao/captainManageDetailsDAO';
import { getCurrentVesselRates } from '../edit/edit.component';
import { PaymentDAO } from '../../../../core/services/dao/paymentDAO';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';
import {
  AdditionalCosts,
  IndividualCost,
} from '../../../../core/models/interface/additional-cost';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { CreatablePayment } from './create-payout-from-payment-dialog/create-payout-from-payment-dialog.component';
import { findMatchingPayout } from '../../../../core/pure-functions/payouts/payout-comparison';
import { VesselRateCalculationService } from '../../../../core/services/vessel-rate-calculation-service';
import { buildSMSModalText } from './manage-charter-rich-text-helper/manage-charter-rich-text-helper';
import { timer } from 'rxjs/internal/observable/timer';
import { CharterAlternateTimeRequestsDAO } from '../../../../core/services/dao/charterAlternateTimeRequestsDAO';
import {
  CharterAlternateTimeRequest,
  CustomerResponses,
} from '../../../../core/charterAlternateTimeRequest';
import { take } from 'rxjs/operators';
import { CharterNoteDAO } from '../../../../core/services/dao/charterNoteDAO';
import { PromoWithTotalDiscount } from 'anchor-shared/lib/model/entity/discount';
import { AdminPromoCodeComponent } from './admin-promo-code/admin-promo-code.component';
import { DiscountDAO } from '../../../../core/services/dao/discountDAO';
import { buildRouteEnding } from '../../../../core/pure-functions/navigation/buyflow-vessel-route-builder/buyflow-vessel-route-builder';
import { VesselAvailabilityDAO } from '../../../../core/services/dao/VesselAvailabilityDAO';
import { PaymentIntent } from '@stripe/stripe-js/types/api/payment-intents';
import { StripePaymentDAO } from '../../../../core/services/dao/stripePaymentDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { environment } from '../../../../environments/environment';
import { CaptainGigDAO } from '../../../../core/services/dao/captainGigDAO';
import { PayoutInfo } from 'anchor-shared/lib/model/interface/payoutInfo';
import { getBoatCaptCrewTotalFromOriginalRates } from 'anchor-shared/lib/service/pure-functions/vessel-helper/vessel-rate-helper';
import { RateType } from 'anchor-shared/lib/model/enum/vessel-rate-types';
import {
  getAddOnCost,
  getAddOnsTotalFromPricingMetaData,
  getDurationTypeForCalcService,
} from 'anchor-shared/lib/service/pure-functions/charter-pricing/charter-pricing-helper';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { OfferDAO } from '../../../../core/services/dao/offerDAO';
import { CustomOfferPayoutsDialogService } from '../../../shared/boat-owner/dialogs/custom-offer-payouts-dialog.service';
import { PaymentType } from 'anchor-shared/lib/model/enum/payment-type';
import { CustomerReviewDAO } from '../../../../core/services/dao/customerReviewDAO';

@Component({
  selector: 'app-manage-charter',
  templateUrl: './manage-charter.component.html',
  styleUrls: ['./manage-charter.component.scss'],
})
export class ManageCharterComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @Input() model: Payment;

  runInvoiceInit = new BehaviorSubject<boolean>(false);
  depositSaved = true;
  charter: Charter;
  charterId: number;
  charterCompleted: boolean;
  payments: Payment[];
  depositRequestSent = false;
  fullPaymentRequestSent = false;
  depositAmount = '';
  captainNotes: string;
  parkingNotes: string;
  rulesNotes: string;
  customerNotes: string;
  headCaptain: string;
  itinerarySent: any;
  costsForm: FormGroup;
  payoutsPublished = false;
  files = [];
  crew = [];
  services = [];
  discounts = [];
  additionalCharges = 0.0;
  totalReconciliation = '0.00';
  ownerProfit: any;
  anchorProfit: number;
  reconciliationPayment: Payment;
  additionalCosts: AdditionalCosts = {
    fuelCosts: {
      gallons: null,
      cost: '0.00',
      costPerGal: null,
    },
    additionalCharges: {
      cost: 0.0,
      individualCosts: [],
    },
    total: '0.00',
  };
  itineraryForm: FormGroup;
  formattedBoatOwnerTextedTime: string;
  additionalHours: number;
  vesselRates: VesselRate[];
  additionalHoursCustomerTotal: number;
  customer: Customer;
  subs: Subscription[] = [];
  discountServiceTotal: number;
  transactionsAdded: boolean;
  customerCard: any;
  paymentMethod: CustomerPaymentMethod;
  paymentsInit: boolean;
  bundledInit: boolean;
  miscPayments: Payment[];
  waterBody: WaterBody;
  charterTimezone: string;
  payoutDateCreated: any;
  payoutTimeCreated: any;
  costsBundledInRemainingBalance: IndividualCost[] = [];
  reconciliationPayments: Payment[];
  fullPaymentRefunds: Payment[] = [];
  fullPaymentRefundAmount: number = 0;
  otherPayments: Payment[];
  otherPaymentsTotalAmount = 0;
  standardPayments: Payment[];
  otherPaymentsInitialized: boolean;
  queryParamIndex: number;
  collapseCharterInfo: boolean;
  runFuelAndAddHoursCalc = new BehaviorSubject<boolean>(false);
  refreshCharterNotes = new BehaviorSubject<boolean>(false);
  refreshAffiliateInfo = new BehaviorSubject<boolean>(false);
  depositPayment: Payment = null;
  fullPayment: Payment = null;
  crewNumber: number;
  originalRates: [];
  getUtcCharterDate;
  loadingSMSInfo = false;
  alternateTimeRequest: Partial<CharterAlternateTimeRequest>;
  timeSelectedEnumValue = CustomerResponses.TIME_SELECTED;
  charterAgreementColumnDefs;
  charterAgreementRowData = [];
  promoCodeApplied: boolean = false;
  promoCode: PromoWithTotalDiscount;
  boatCaptCrewTotal: number;
  private vessel: Vessel;
  listingPageURL: string;
  charterer: User;
  currentRefundPayment: Payment;
  isMobile: boolean;
  PaymentType = PaymentType;

  constructor(
    private charterDao: CharterDAO,
    private payoutDao: PayoutDAO,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private uploadDao: UploadDAO,
    private dialog: MatDialog,
    private cancelCharterDialog: MatDialog,
    private cd: ChangeDetectorRef,
    private dialogService: DialogsService,
    private formatter: NumberFormatterService,
    private vesselRateCalcService: VesselRateCalculationService,
    private vesselDAO: VesselDAO,
    private vesselRateDAO: VesselRateDAO,
    private appMessagingService: AppMessagingService,
    private customerDAO: CustomerDAO,
    private chickenTestDialog: ChickenTestDialogService,
    private mooringLocationDAO: MooringLocationDAO,
    private paymentDAO: PaymentDAO,
    private captainManageDetailDao: CaptainManageDetailsDAO,
    private waterBodyDAO: WaterBodyDAO,
    private userDAO: UserDAO,
    private charterAlternateTimeRequestDAO: CharterAlternateTimeRequestsDAO,
    private charterNoteDAO: CharterNoteDAO,
    private discountDAO: DiscountDAO,
    private vesselAvailabilityDAO: VesselAvailabilityDAO,
    private stripePaymentDAO: StripePaymentDAO,
    private captainGigDAO: CaptainGigDAO,
    private offerDAO: OfferDAO,
    private customOfferPayoutsDialogService: CustomOfferPayoutsDialogService,
    private customerReviewDAO: CustomerReviewDAO,
    private breakpointObserver: BreakpointObserver,
  ) {
    const routeSub = this.route.data.subscribe((data) => {
      this.itineraryForm = new FormGroup({
        customerNotes: new FormControl('', [Validators.required]),
        captainNotes: new FormControl('', [Validators.required]),
        parkingNotes: new FormControl('', [Validators.required]),
        rulesNotes: new FormControl('', [Validators.required]),
        headCaptain: new FormControl('', [
          Validators.required,
          Validators.email,
        ]),
      });
      this.getUtcCharterDate = getUtcCharterDate;
      this.charterId = this.route.snapshot.params.id;
      this.loadArchivedSignedCA();
      this.charter = data.charter.charterResolve;
      if (this.charter.pricingMetaData.addOns?.length > 0) {
        this.charter.pricingMetaData.addOns =
          this.charter.pricingMetaData.addOns.map((x) => ({
            ...x,
            markupPrice: getAddOnCost(x, true),
          }));
      }
      const vesselSub = this.vesselDAO
        .loadById(this.charter.vesselId)
        .subscribe((loadedVessel) => {
          this.vessel = loadedVessel;
          this.listingPageURL =
            'vessels/yacht-and-boat-rentals/' + buildRouteEnding(this.vessel);
        });
      this.subs.push(vesselSub);
      this.initPayments();
      this.setCustomerObs();
      this.readQueryParams();
      const rateSub = this.vesselRateDAO
        .loadForVessel(this.charter.vesselId)
        .subscribe((rates) => {
          this.vesselRates = getCurrentVesselRates(rates, this.charter);
          if (this.charter.waterBodyId) {
            const waterBodySub = this.waterBodyDAO
              .getByWaterBodyId(this.charter.waterBodyId)
              .subscribe((waterBody) => {
                this.waterBody = waterBody;
                this.charterTimezone = waterBody.timezone.replace(/_/g, ' ');
              });
            this.subs.push(waterBodySub);
          }
          if (this.charter.services) {
            this.services = this.formatter.parseJsonIfString(
              this.charter.services,
            );
          }
          if (this.charter.discounts) {
            this.discounts = this.formatter.parseJsonIfString(
              this.charter.discounts,
            );
          }
          if (this.charter.payments) {
            this.miscPayments = this.charter.payments.filter(
              (payment: Payment) => payment.type === PaymentType.MANUAL,
            );
          }

          this.formattedBoatOwnerTextedTime = moment(
            this.charter.boatOwnerTextedTime,
          ).format('YYYY-MM-DD hh:mm a');
          this.charterCompleted = this.charter.completed;
          this.payments = [];
          this.charter.payments.forEach((payment) => {
            if (payment.type !== PaymentType.REFUND) {
              this.payments.push(payment);
            } else {
              this.fullPaymentRefunds.push(payment);
            }
          });
          this.calculateFullPaymentRefunds();
          if (this.payments) {
            this.reconciliationPayments = this.charter.payments.filter(
              (payment) => payment.name === 'Reconciliation',
            );
            this.reconciliationPayments.forEach((recon) => {
              recon.transactions = this.formatter.parseJsonIfString(
                recon.transactions,
              );
            });
          }
          this.depositAmount = this.charter.depositAmount as any;
          if (this.charter.additionalCosts) {
            this.additionalCosts = parseJson(this.charter.additionalCosts);
            this.additionalCosts.additionalCharges.cost = Number(
              this.additionalCosts.additionalCharges.cost,
            );
            if (!this.additionalCosts.additionalCharges.individualCosts) {
              this.additionalCosts.additionalCharges.individualCosts = [];
            }
            this.additionalCosts.additionalCharges.individualCosts.some(
              (item) => {
                if (item.description === 'Additional Hours') {
                  this.additionalHoursCustomerTotal = Number(item.total);
                  return true;
                }
              },
            );
          }
          this.additionalCosts.fuelCosts.costPerGal = this.charter.fuelCost;
          this.initItineraryNotes();
          this.additionalHours = Number(this.additionalHours);
          this.additionalCharges = Number(
            this.additionalCosts.additionalCharges.cost,
          );
          this.discountServiceTotal = getCharterDiscountServiceTotal(
            this.charter,
          );
          this.initOtherPayments();
          this.transactionsAdded = false;
          this.paymentsInit = false;
          this.bundledInit = false;
          this.otherPaymentsInitialized = false;
        });
      this.subs.push(rateSub);
    });
    this.subs.push(routeSub);
    this.processRefund = this.processRefund.bind(this);

    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
  }

  ngOnInit() {
    this.initBundledPayments();
    this.initPaymentsWithPayouts();
    this.initAvailableAtAnotherTimeCheck();
    this.initPromoCodeCheck();
    this.getCharterer();
    this.crew = this.formatter.parseArrayFromJson(this.charter.crew);
    if (this.crew) {
      // Reformat crew for charters made before R35
      this.crew = this.crew.map((member: Partial<CrewMember>) => {
        if (!member.user) {
          member = {
            id: member.id,
            // @ts-ignore
            user: {
              firstName: member.user.firstName,
              lastName: member.user.lastName,
              email: member.user.email,
              phoneNumber: member.user.phoneNumber,
            },
          };
        }
        return member;
      });
    }
    this.services = this.formatter.parseArrayFromJson(this.charter.services);

    this.costsForm = new FormGroup({
      fuel: new FormControl('', [Validators.pattern(/^-?[0-9]\d*(\.\d+)?$/)]),
      additional: new FormControl('', [
        Validators.pattern(/^-?[0-9]\d*(\.\d+)?$/),
      ]),
    });
    this.additionalCharges =
      this.getFuelCost() + Number(this.additionalCosts.additionalCharges.cost);
    setTimeout(() => {
      this.tabGroup.selectedIndex = this.queryParamIndex
        ? this.queryParamIndex
        : 0;
    }, 500);
    this.cd.detectChanges();
    this.originalRates = this.formatter.parseJsonIfString(
      this.charter.originalRates,
    );
    this.crewNumber = this.countCrew(this.originalRates);
  }

  getCharterer() {
    if (!this.charter.userId) return;
    const userSub = this.userDAO
      .getById(this.charter.userId)
      .subscribe((user) => {
        this.charterer = user;
      });
    this.subs.push(userSub);
  }

  countCrew(originalRates: []): number {
    let count = 0;
    let removeDuplicates = originalRates.filter((value, index) => {
      const _value = JSON.stringify(value);
      return (
        index ===
        originalRates.findIndex((obj) => {
          return JSON.stringify(obj) === _value;
        })
      );
    });
    removeDuplicates.map((item) => {
      // @ts-ignore
      if (item.rateType === 'Crew') {
        count += 1;
      }
    });
    return count;
  }

  loadArchivedSignedCA() {
    this.charterAgreementColumnDefs = [
      {
        headerName: 'Date',
        field: 'date',
      },
    ];
    const sub = this.uploadDao
      .getArchivedSignedCA(this.charterId)
      .subscribe((CAs) => {
        if (CAs && CAs.Contents.length > 0) {
          CAs.Contents.map((ca) => {
            if (ca.Size > 0) {
              this.charterAgreementRowData.push({
                date: this.returnDateFromFileName(ca.Key),
                fileName: this.returnFileName(ca.Key),
                id: ca.Key,
              });
            }
          });
        }
      });
    this.subs.push(sub);
  }

  returnDateFromFileName(key: string) {
    return moment(key.split('_')[1].split('.')[0], 'x').format('LLL');
  }

  returnFileName(key: string): string {
    return key.split('/')[3];
  }

  cancelCharter() {
    const cancelCharterSub = this.cancelCharterDialog
      .open(CancelCharterChickenTestComponent, {
        data: { charter: this.charter, cancellee: 'Admin' },
      })
      .afterClosed()
      .subscribe((data) => {
        if (data && data.cancelled) {
          const admin = this.userDAO.getCurrentUser();
          this.charter.cancelled = true;
          this.charter.completed = false;
          this.charter.open = false;
          const cancelCharterNote = this.charterNoteDAO
            .saveNote(
              this.charter.id,
              `
          CHARTER CANCELED

          Date: ${moment().format('LLLL')}
          By: ${admin.firstName} ${admin.lastName}
          Boat owner notified by SMS: ${data.textBoatOwner ? 'YES' : 'NO'}
          Captain notified by SMS: ${data.textCaptain ? 'YES' : 'NO'}
          Reason:
          ${data.cancellationReason}
          `,
            )
            .subscribe();
          this.subs.push(cancelCharterNote);

          const charterUpdate = this.charterDao
            .updateFromPartial(this.charter.id, {
              cancelled: this.charter.cancelled,
              completed: this.charter.completed,
              open: this.charter.open,
            })
            .pipe(take(1));

          const vesselAvailabilityUpdate = this.vesselAvailabilityDAO
            .updateSingleDayAvailabilityForVessel(
              this.vessel.id,
              this.charter.date,
            )
            .pipe(take(1));

          concat(charterUpdate, vesselAvailabilityUpdate).subscribe();
        }
      });
    this.subs.push(cancelCharterSub);
  }

  uncancelCharter() {
    this.charter.cancelled = false;

    if (this.charter.paymentReceived) {
      this.charter.open = true;
    }

    const charterUpdate = this.charterDao
      .updateFromPartial(this.charter.id, {
        cancelled: this.charter.cancelled,
        completed: this.charter.completed,
        open: this.charter.open,
      })
      .pipe(take(1));

    const vesselAvailabilityUpdate = this.vesselAvailabilityDAO
      .updateSingleDayAvailabilityForVessel(this.vessel.id, this.charter.date)
      .pipe(take(1));

    concat(charterUpdate, vesselAvailabilityUpdate).subscribe(() => {
      this.appMessagingService.openSnack('Charter Un-canceled successfully');
    });
  }

  initPaymentsWithPayouts() {
    let matchingPayment;
    if (this.charter && this.charter.payouts) {
      this.charter.payouts.forEach((payout: Payout) => {
        matchingPayment = this.charter.payments.find(
          // @ts-ignore
          (payment: Payment) => payment.id === payout.paymentId,
        );
        if (matchingPayment) {
          // @ts-ignore
          matchingPayment.payoutCreatedDate = payout.createdAt
            ? // @ts-ignore
              payout.createdAt
            : true;
        }
      });
    }
  }

  initPayments() {
    this.charter.payments.forEach((payment) => {
      if (payment.type === PaymentType.DEPOSIT) {
        this.depositRequestSent = true;
        this.depositPayment = payment;
      }
      if (payment.type === PaymentType.FULL) {
        this.fullPaymentRequestSent = true;
        this.fullPayment = payment;
      }
      if (
        payment.type === PaymentType.RECONCILIATION ||
        payment.name === 'Post Charter Refund'
      ) {
        this.reconciliationPayment = payment;
      }
      if (payment.transactions) {
        payment.transactions = parseJson(payment.transactions);
      }
    });
    this.paymentsInit = true;
  }

  initBundledPayments() {
    this.costsBundledInRemainingBalance =
      this.additionalCosts.additionalCharges.individualCosts.filter(
        (cost) => cost.type === 'manual' && !cost.charterPaidAtCreation,
      );
    this.bundledInit = true;
  }

  initOtherPayments() {
    this.otherPayments = this.payments.filter(
      (payment) =>
        (payment.manual && !payment.paymentIntentId) ||
        (payment.paymentIntentId && !payment.transactions),
    );
    // @ts-ignore
    this.standardPayments = this.payments.filter(
      (payment) =>
        !payment.manual ||
        (payment.paymentIntentId &&
          payment.paymentIntentId.includes('pi') &&
          payment.transactions),
    );

    this.payments = this.payments.filter((payment) => !payment.manual);
    const paymentTypes: PaymentType[] = [
      PaymentType.DEPOSIT,
      PaymentType.REMAINING,
      PaymentType.FULL,
    ];

    this.otherPaymentsTotalAmount = 0;
    this.otherPaymentsInitialized = false;

    if (!this.otherPaymentsInitialized) {
      this.otherPayments.forEach((payment: Payment) => {
        // If payment is an 'other' payment and it is marked as failed, that payment was removed
        // If payment is of type 'addOn' do not include it here as it is handled with other add ons
        if (!payment.failed && !paymentTypes.includes(payment.type)) {
          this.otherPaymentsTotalAmount += parseFloat(payment.amount);
        }
      });
    }
    this.otherPaymentsInitialized = true;
  }

  fetchPayments() {
    const paymSub = this.paymentDAO
      .getPaymentsByCharterId(this.charter.id)
      .subscribe((payments) => {
        this.charter.payments = payments;
        this.payments = payments;
        this.initPayments();
        this.initOtherPayments();
      });
  }

  finalizeAdjustmentPayment(payment) {
    const readOnlyTransactionData = {
      paymentId: payment.id,
      paymentType: 'stripe',
      paymentTypeOptions: ['stripe'],
      paymentAmount: payment.amount,
      paymentTitle: payment.name,
      paymentDescription: `Adjustment payment - ${payment.name}`,
      transactionType: 'adjustment',
    };
    this.addNewTransaction(readOnlyTransactionData);
  }

  uploadAgreement(event) {
    const file = event.target.files[0];
    const uploadPath = `forms/charter-${this.charter.id}-agreement.pdf`;
    const fileUploadSub = this.uploadDao
      .uploadFileDynamicPath(file, uploadPath)
      .subscribe((data) => {
        this.charter.signedAgreementUrl = data.filepath;
        this.charter.agreementSignedDate = new Date();
        this.charter.agreementUploadDate = new Date();
        const charterUpdateSub = this.charterDao
          .updateFromPartial(this.charter.id, {
            agreementUrl: this.charter.signedAgreementUrl,
            signedAgreementUrl: this.charter.signedAgreementUrl,
            agreementSignedDate: this.charter.agreementSignedDate,
            agreementUploadDate: this.charter.agreementUploadDate,
            shouldArchiveAgreement: true,
          })
          .subscribe((_data) => {});
        this.subs.push(charterUpdateSub);
      });
    this.subs.push(fileUploadSub);
  }

  convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    const ctrl = absCtrl as FormControl;
    return ctrl;
  }

  editAgreement() {
    if (
      this.charter.payouts &&
      this.charter.payouts.length &&
      this.charter.completed
    ) {
      const chickenSub = this.chickenTestDialog
        .open(
          'Are you sure you want to edit this charter? You will need to regenerate ' +
            'payouts and any existing changes will need to be redone.',
          'Yes, continue to edit',
          'Cancel',
          60,
        )
        .subscribe((continueToEdit) => {
          if (continueToEdit) {
            this.router.navigate([
              'manage',
              'charters',
              this.charterId,
              'edit',
            ]);
          }
        });
      this.subs.push(chickenSub);
    } else {
      this.router.navigate(['manage', 'charters', this.charterId, 'edit']);
    }
  }

  formatDate(date: Date) {
    return moment(date).format('MM/DD/YYYY hh:mm a');
  }

  initItineraryNotes() {
    const itinerary: CharterItinerary = parseJson(
      this.charter.itinerary as any,
    );
    if (itinerary) {
      this.captainNotes = addNewLines(itinerary.captainNotes);
      this.parkingNotes = addNewLines(itinerary.parkingInstructions);
      this.rulesNotes = addNewLines(itinerary.rulesOfTheBoat);
      this.customerNotes = addNewLines(itinerary.passengerNotes);
      this.headCaptain = itinerary.headCaptain;
      this.itinerarySent = moment(itinerary.sent).format('MM/DD/YYYY');
    }
  }

  resendDepositRequest(id) {
    const params = {
      charterId: this.charterId,
      charterDate: getUtcCharterDate(this.charter).format('MM/DD/YYYY'),
      paymentId: id,
    };
    this.sendDepositEmail(params);
    const availabilityUpdateSub = this.charterDao
      .updateFromPartial(this.charterId, {
        availabilityStatus: 'Available',
      })
      .subscribe();
    this.subs.push(availabilityUpdateSub);
  }

  displayPriceDetails(): void {
    const charterForPriceDetails = this.charter;
    const vesselSub = this.vesselDAO
      .loadById(this.charter.vesselId)
      .subscribe((loadedVessel) => {
        const vessel = loadedVessel;
        this.dialogService.CharterPriceDetailDialog(
          'all',
          charterForPriceDetails.payouts,
          this.getDurationType(charterForPriceDetails.duration),
          charterForPriceDetails.duration,
          vessel,
          charterForPriceDetails.discounts,
          this.services,
          this.isMobile,
          this.vesselRates,
          charterForPriceDetails,
          false,
        );
      });
    this.subs.push(vesselSub);
  }

  initModel() {
    return {
      vesselId: '',
      captainId: '',
      customerFirstName: '',
      customerEmail: '',
      customerPhoneNumber: '',
      numOfPassengers: null,
      boatName: '',
      boatMake: '',
      boatModel: '',
      boatYear: '',
      boatOwnerFirstName: '',
      boatOwnerLastName: '',
      boatOwnerEmail: '',
      boatOwnerPhone: '',
      captainFirstName: '',
      captainLastName: '',
      captainEmail: '',
      captainPhoneNumber: '',
      date: new Date(),
      startTime: '',
      endTime: '',
      charterTotal: '',
      fuelCost: '',
      open: true,
      completed: false,
      cancelled: false,
      crew: null,
      services: null,
      depositAmount: '',
      depositPayed: false,
      depositStatus: 'NOT SENT',
      remainderStatus: 'NOT SENT',
      reconciliationStatus: 'NOT SENT',
    };
  }

  saveItinerary() {
    const itinerary: Partial<CharterItinerary> = {
      captainNotes: this.preserveLineBreaks(this.captainNotes),
      passengerNotes: this.preserveLineBreaks(this.customerNotes),
      headCaptain: this.headCaptain,
      parkingInstructions: this.preserveLineBreaks(this.parkingNotes),
      rulesOfTheBoat: this.preserveLineBreaks(this.rulesNotes),
    };
    this.charter.itinerary = JSON.stringify(itinerary) as any;
    const charterUpdateSub = this.charterDao
      .updateFromPartial(this.charter.id, { itinerary: this.charter.itinerary })
      .subscribe((data) => {
        this.openSnackbar('Itinerary saved');
      });
    this.subs.push(charterUpdateSub);
  }

  sendItinerary() {
    const mooringSub = this.mooringLocationDAO
      .getByVesselId(this.charter.vesselId)
      .subscribe((mooringLocation) => {
        let parkingAddress = '';
        let parkingAddressLink = '';
        let mooringAddress = '';
        let mooringAddressLink = '';

        if (mooringLocation.parkingAddress) {
          parkingAddress = mooringLocation.parkingAddress;
          parkingAddressLink = `https://maps.google.com/?q=${mooringLocation.parkingLat},${mooringLocation.parkingLong}`;
        }

        if (mooringLocation.address) {
          mooringAddress = mooringLocation.address;
          mooringAddressLink = `https://maps.google.com/?q=${mooringLocation.lat},${mooringLocation.long}`;
        }
        if (this.discountServiceTotal) {
          this.discountServiceTotal = parseFloat(
            this.discountServiceTotal.toFixed(2),
          );
        }
        const data = {
          customerName:
            this.charter.customerFirstName +
            ' ' +
            this.charter.customerLastName,
          customerEmail: this.charter.customerEmail,
          customerPhone: this.charter.customerPhoneNumber,
          start_Time: this.charter.startTime,
          charterStart: this.charter.startTime,
          charterEnd: this.charter.charterEndTime,
          charterDate: getUtcCharterDate(this.charter),
          captainName:
            this.charter.captainFirstName + ' ' + this.charter.captainLastName,
          captainEmail: this.charter.captainEmail,
          captainPhone: this.charter.captainPhoneNumber,
          captainNotes: this.preserveLineBreaks(this.captainNotes),
          passengerNotes: this.preserveLineBreaks(this.customerNotes),
          agreementUrl: this.charter.signedAgreementUrl,
          headCaptain: this.headCaptain,
          charterId: this.charter.id,
          boatName: this.charter.boatName,
          duration: this.charter.duration,
          boatLocation: this.charter.boat.dockInfo,
          parkingNotes: this.preserveLineBreaks(this.parkingNotes),
          parkingAddress: parkingAddress,
          parkingAddressLink: parkingAddressLink,
          mooringAddress: mooringAddress,
          mooringAddressLink: mooringAddressLink,
          instructionsAndRules: this.preserveLineBreaks(this.rulesNotes),
          boatFeaturedImage: this.charter.boat.primaryPhotoAbsPath,
          customerCharterLink:
            window.location.origin +
            '/customer/charter-details/' +
            this.charterId,
          depositAmount: this.depositAmount,
          remainingAmount: this.discountServiceTotal,
          passengerCount: this.charter.numOfPassengers,
          boatMake: this.charter.boat.make,
          boatModel: this.charter.boat.model,
          boatYear: this.charter.boat.yearBuilt,
        };
        if (data.captainEmail) {
          const itinerary = {
            captainNotes: this.preserveLineBreaks(this.captainNotes),
            passengerNotes: this.preserveLineBreaks(this.customerNotes),
            headCaptain: this.headCaptain,
            parkingInstructions: this.preserveLineBreaks(this.parkingNotes),
            rulesOfTheBoat: this.preserveLineBreaks(this.rulesNotes),
            sent: new Date().toUTCString(),
          };
          this.charter.itinerary = JSON.stringify(itinerary) as any;
          const charterUpdateSub = this.charterDao
            .updateFromPartial(this.charter.id, {
              itinerary: this.charter.itinerary,
            })
            .subscribe(() => {
              const itinerarySub = this.charterDao
                .sendItineraryNotes(data)
                .subscribe(() => {
                  this.openSnackbar('Itinerary successfully sent');
                });
              this.subs.push(itinerarySub);
            });
          this.subs.push(charterUpdateSub);
        } else {
          this.dialog.open(NoCaptainModalComponent);
        }
      });
    this.subs.push(mooringSub);
  }

  preserveLineBreaks(text) {
    if (text) {
      return text.replace(/\r\n|\r|\n/g, '<br>');
    } else {
      return '';
    }
  }

  sendFullPaymentRequest() {
    const amount =
      // @ts-ignore
      parseFloat(this.charter.charterTotal) + parseFloat(this.depositAmount);
    const payment = {
      type: 'full',
      charterId: this.charterId,
      amount: amount,
      paid: false,
      failed: false,
    };
    const paymentRequestSub = this.charterDao
      .sendPaymentRequest(payment)
      .subscribe((data) => {
        this.payments = data.payments;
        this.initPayments();
        const body = {
          email: this.charter.customerEmail,
          name:
            this.charter.customerFirstName +
            ' ' +
            this.charter.customerLastName,
          charterAmount: amount,
          charterId: this.charterId,
          charterDate: getUtcCharterDate(this.charter).format('MM/DD/YYYY'),
        };
        this.sendFullPaymentEmail(body);
      });
    this.subs.push(paymentRequestSub);
    const availabilityUpdateSub = this.charterDao
      .updateFromPartial(this.charterId, {
        availabilityStatus: 'Available',
      })
      .subscribe();
    this.subs.push(availabilityUpdateSub);
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  sendDepositEmail(body) {
    const emailSub = this.charterDao
      .sendUserDepositEmail(body)
      .subscribe((response) => {
        this.openSnackbar(
          `Deposit request sucessfully sent to ${this.charter.customerEmail}`,
        );
      });
    this.subs.push(emailSub);
  }

  sendFullPaymentEmail(body) {
    const emailSub = this.charterDao
      .sendUserFullPaymentEmail(body)
      .subscribe((response) => {
        this.openSnackbar(
          `Full payment request successfully sent to ${this.charter.customerEmail}`,
        );
      });
    this.subs.push(emailSub);
  }

  dlAgreement() {
    if (this.charter.agreementUrl) {
      const bust = '?cache=' + Math.random() * 1000;
      window.open(this.charter.agreementUrl + bust, '_blank');
    } else {
      const agreementSub = this.charterDao
        .createCharterAgreement(this.charterId)
        .subscribe((charter: Charter) => {
          window.open(charter.agreementUrl, '_blank');
        });
      this.subs.push(agreementSub);
    }
  }

  regenerateCharterAgreement(): void {
    const chickenSub = this.chickenTestDialog
      .open(
        'Are you sure you want to recreate the charter agreement, this will delete the current one on the charter?',
        'Yes, regenerate',
        'No, cancel',
        60,
      )
      .subscribe((regenerate) => {
        if (regenerate) {
          const updateSub = this.charterDao
            .updateFromPartial(this.charter.id, {
              agreementCreatedDate: null,
              agreementSignedDate: null,
              agreementUrl: null,
              signedAgreementUrl: null,
            })
            .subscribe((updated) => {
              this.appMessagingService.openSnack(
                'Success! You have regenerated the charter agreement.',
              );
            });
          this.subs.push(updateSub);
        }
      });
    this.subs.push(chickenSub);
  }

  openAgreementSigningLink(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        'customer/charter/' + this.charter.id + '/agreement',
      ]),
    );
    window.open(url, '_blank');
  }

  sendAgreementToCustomer(): void {
    const chickenSub = this.chickenTestDialog
      .open(
        'Are you sure?  This will send an email to ' +
          this.charter.customerEmail,
        'Yes, send',
        'No, cancel',
        60,
      )
      .subscribe((resend) => {
        if (resend) {
          const sendSub = this.charterDao
            .sendAgreementEmailToCustomer(this.charter.id)
            .subscribe((updated) => {
              this.appMessagingService.openSnack(
                'Success! You have resent the charter agreement.',
              );
            });
          this.subs.push(sendSub);
        }
      });
    this.subs.push(chickenSub);
  }

  ngOnDestroy(): void {
    this.initModel();
    unsubscribeFromAll(this.subs);
  }

  private getDurationType(duration: number): 0 | 4 | 8 {
    if (duration === 4) {
      return 4;
    } else if (duration === 8) {
      return 8;
    } else {
      return 0;
    }
  }

  getFuelCost(): number {
    if (this.charter.boat.fuelIncluded) {
      return 0;
    }
    return (
      this.additionalCosts.fuelCosts.gallons * this.charter.boat.fuelBillingRate
    );
  }

  showPayoutButton(payment): boolean {
    return (
      !payment.payoutCreatedDate &&
      payment.type !== PaymentType.DEPOSIT &&
      payment.type !== PaymentType.REMAINING &&
      payment.type !== PaymentType.FULL &&
      !payment.refunded &&
      !payment.failed
    );
  }

  showCreatePayoutForBundledObject(bundledCost: IndividualCost): boolean {
    return !bundledCost.payoutCreatedDate;
  }

  showRefundButton(payment: Payment): boolean {
    if (
      payment.type === PaymentType.DEPOSIT &&
      !this.charter.completed &&
      !payment.refunded
    ) {
      return true;
    }

    if (
      Number(payment.amount) > this.fullPaymentRefundAmount &&
      payment.transactionId &&
      payment.type !== PaymentType.REFUND &&
      this.userDAO.currentUserIs('Finance') &&
      !payment.failed &&
      payment.type !== PaymentType.DEPOSIT
    ) {
      return true;
    } else {
      return false;
    }
  }

  private setCustomerObs(): void {
    this.customerDAO
      .adminGetForUser(this.charter.userId)
      .pipe(take(1))
      .subscribe((customer) => {
        this.customer = customer;
      });
  }

  refreshNotes(): void {
    this.refreshCharterNotes.next(true);
  }

  refreshCharterItinerary() {
    const chickenTestSub = this.chickenTestDialog
      .open(
        'Are you sure you want to get the latest itinerary info? All itinerary data will be changed.',
        'Yes, replace',
        'No, cancel',
        43,
      )
      .subscribe((shouldRefresh) => {
        if (shouldRefresh) {
          this.vesselDAO
            .getVesselNotes(this.charter.vesselId)
            .subscribe((vessel: Vessel) => {
              this.parkingNotes = vessel.parkingNotes;
              this.rulesNotes = vessel.instructionsAndRules;
              this.captainNotes = vessel.specialInstructions;
            });
        }
      });
    this.subs.push(chickenTestSub);
  }

  refreshSMSData(showModalAfter: boolean): void {
    this.loadingSMSInfo = true;
    const obs = this.charterDao.getBoatOwnerSMSInfo(this.charterId);
    const updateInfoSub = combineLatest(obs, timer(1000)).subscribe(
      (combinedResults) => {
        const smsInfo: BoatOwnerSMSInfo = combinedResults[0];
        this.loadingSMSInfo = false;
        this.charter.boatOwnerTextedTime = smsInfo.boatOwnerTextedTime;
        this.formattedBoatOwnerTextedTime = moment(
          this.charter.boatOwnerTextedTime,
        ).format('YYYY-MM-DD hh:mm a');
        this.charter.remainderStatus = smsInfo.remainderStatus;
        this.charter.availabilityStatus = smsInfo.availabilityStatus;
        this.charter.unavailableReason = smsInfo.unavailableReason;
        if (showModalAfter) {
          const modalText = buildSMSModalText(this.charter);
          this.sendBoatOwnerSMS(modalText);
        }
      },
      (error) => {
        this.loadingSMSInfo = false;
      },
    );
    this.subs.push(updateInfoSub);
  }

  sendBoatOwnerSMS(modalText: string) {
    const chickenSub = this.chickenTestDialog
      .open(
        modalText,
        'Yes, send',
        'No, cancel',
        undefined,
        undefined,
        undefined,
        true,
      )
      .subscribe((response) => {
        if (response) {
          const smsSub = this.charterDao
            .adminSendBoatOwnerText(this.charterId)
            .subscribe((res) => {
              this.appMessagingService.openSnack('Message sent');
              this.formattedBoatOwnerTextedTime =
                moment().format('YYYY-MM-DD HH:mm a');
            });
          this.subs.push(smsSub);
        }
      });
    this.subs.push(chickenSub);
  }

  addNewTransaction(readOnlyTransactionData = null) {
    this.transactionsAdded = true;
    const dialogSub = this.dialogService
      .AddNewTransactionDialog(
        this.charter,
        this.charter.userId,
        this.charter.remainderStatus,
        this.depositPayment,
        this.fullPayment,
        this.isMobile,
        readOnlyTransactionData,
      )
      .subscribe((result: any) => {
        if (result && result?.adminResponse) {
          this.charterDao
            .getByIdManageCharter(this.charter.id)
            .subscribe((charter) => {
              this.charter = charter;
              this.payments = charter.payments;
              this.initOtherPayments();
              this.miscPayments = charter.payments.filter(
                (payment: Payment) => payment.type === PaymentType.MANUAL,
              );
              this.initPayments();
              this.initPaymentsWithPayouts();
              this.initBundledPayments();

              this.services = this.formatter.parseArrayFromJson(
                charter.services,
              );

              this.discountServiceTotal = getCharterDiscountServiceTotal(
                this.charter,
              );
            });
        } else if (
          result &&
          !result.adminResponse &&
          result &&
          result.paymentIntent
        ) {
          this.stripePaymentDAO
            .cancelPaymentIntent(result.paymentIntent.id)
            .pipe(take(1))
            .subscribe();
        }
      });
    this.subs.push(dialogSub);
  }

  processRefund(values) {
    const refundPayment = { ...this.currentRefundPayment };
    refundPayment.amount = values.amount;
    refundPayment.notes = values.description;

    const refundSub = this.charterDao
      .refundManualTransaction(refundPayment, this.charter.customerEmail)
      .subscribe((refund) => {
        if (refund) {
          this.charter.payments.push(refund);
          this.fullPaymentRefunds.push(refund);
          this.calculateFullPaymentRefunds();
          this.onRefundSuccess();
        } else {
          this.openSnackbar('Refund unsuccessful. Contact IT for support.');
        }
        this.currentRefundPayment = null;
      });
    this.subs.push(refundSub);
  }

  refundValidator({ amount, description }) {
    if (
      Number(amount) >
      Number(this.currentRefundPayment.amount) - this.fullPaymentRefundAmount
    ) {
      return {
        valid: false,
        error: 'Refund must be less than remaining payment amount.',
      };
    }
    if (amount < 0 || !amount) {
      return {
        valid: false,
        error: 'Please provide a refund value greater than 0.',
      };
    }
    if (!description) {
      return {
        valid: false,
        error:
          'Please provide a detailed description of the reason for the refund.',
      };
    }
    return { valid: true };
  }

  refundTransaction(payment: Payment) {
    this.currentRefundPayment = payment;
    const rate = this.vesselRates.find(
      (vr) =>
        vr.rateType === RateType.BookingFee ||
        vr.name?.toLowerCase().includes(RateType.BookingFee.toLowerCase()),
    ); // check name as backup
    const refundAmount = Number(payment.amount);
    let refundDetails: { key: string; value: number }[] = [
      {
        key: 'Full refund',
        value: refundAmount,
      },
      {
        key: '< 14 days',
        value: 0,
      },
    ];

    if (rate) {
      // only display rate required breakdowns if rate is found
      const bookingRate = this.vesselRateCalcService.calculateVesselRate(
        rate,
        getDurationTypeForCalcService(this.charter.duration),
        this.charter.duration,
        true,
      );

      refundDetails.splice(
        1,
        0,
        {
          key: '> 30 days',
          value: refundAmount - bookingRate,
        },
        {
          key: '14-30 days',
          value: (refundAmount - bookingRate) / 2,
        },
      );
    }
    const refundDetailsObj = refundDetails.map(({ key, value }) => ({
      key,
      value: `$${value.toFixed(2)}`,
    }));

    if (payment.type === PaymentType.DEPOSIT) {
      this.chickenTestDialog
        .open(
          'Are you sure you want to refund this deposit?',
          'Refund deposit',
          'Cancel',
          null,
          null,
          null,
        )
        .subscribe((res) => {
          if (res) {
            this.stripePaymentDAO
              .cancelPaymentIntent(payment.paymentIntentId)
              .pipe(take(1))
              .subscribe((res) => {
                const depositPaymentIdx = this.payments.findIndex(
                  (x) => x.paymentIntentId === payment.paymentIntentId,
                );
                this.payments[depositPaymentIdx].refundAmount = payment.amount;
                this.onRefundSuccess();
              });
          }
        });
    } else {
      this.dialogService.refundTransactionDialog(
        payment,
        Number(payment.amount) - this.fullPaymentRefundAmount,
        (values) => this.refundValidator(values),
        (values) => this.processRefund(values),
        { refundDetails: refundDetailsObj, showDescription: true },
      );
    }
  }

  calculateFullPaymentRefunds() {
    this.fullPaymentRefundAmount = this.fullPaymentRefunds.reduce(
      (acc, curr) => acc + Math.abs(Number(curr.amount)),
      0,
    );
  }

  createPayoutFromPayment(payment: Payment): void {
    const creatable: CreatablePayment = {
      amount: payment.amount,
      name: payment.name,
      id: payment.id,
      notes: payment.notes,
    };
    this.createPayoutFromCreatable(creatable);
  }

  createPayoutForBundledObject(cost: IndividualCost): void {
    const creatable: CreatablePayment = {
      amount: cost.total,
      name: cost.title,
      costUUID: cost.uuid,
      notes: cost.description,
    };
    this.createPayoutFromCreatable(creatable);
  }

  createPayoutFromCreatable(creatable: CreatablePayment): void {
    const payoutFromPaymentSub = this.dialogService
      .CreatePayoutFromPayment(creatable, this.charter)
      .subscribe((res: any) => {
        if (!res) {
          return;
        }
        this.additionalCosts = res.additionalCost;
        // if payout was created from a payment object
        if (creatable.id) {
          const updatePayoutSub = this.payoutDao
            .updateFromPartial(res.newPayout.id, {
              // @ts-ignore
              paymentId: creatable.id,
            })
            .subscribe();
          this.subs.push(updatePayoutSub);
          this.charter.payments = this.charter.payments.map((payment) => {
            if (creatable.id === payment.id) {
              // @ts-ignore
              payment.payoutCreatedDate = moment().utc().format();
            }
            return payment;
          });
        }
      });
    this.subs.push(payoutFromPaymentSub);
  }

  checkIfNamesMatch(payment: Payment): string {
    if (
      payment.transactions &&
      payment.transactions?.creditCard?.cardholderName ===
        `${this.charter.customerFirstName} ${this.charter.customerLastName}`
    ) {
      return 'tr-green';
    } else {
      return 'tr-red';
    }
  }

  removeTransactionBeforeFullPayment(bundledCost: IndividualCost) {
    const chickenTestSub = this.chickenTestDialog
      .open(
        `Are you sure you would like to remove "${bundledCost.title}" for $${bundledCost.total}?`,
        'Remove',
        'Cancel',
      )
      .subscribe((response) => {
        if (response) {
          this.additionalCosts.additionalCharges.individualCosts =
            this.additionalCosts.additionalCharges.individualCosts.filter(
              (payment) => {
                if (payment.uuid !== bundledCost.uuid) {
                  return true;
                }
                this.charter.serviceTotal -= parseFloat(bundledCost.total);
                return false;
              },
            );

          if (bundledCost.payoutCreatedDate) {
            const matchingPayout = findMatchingPayout(
              bundledCost,
              this.charter,
            );
            if (matchingPayout) {
              this.charter.payouts = this.charter.payouts.filter(
                (payout) => matchingPayout.id !== payout.id,
              );
              const deleteSub = this.payoutDao
                .deleteMultiple([matchingPayout.id])
                .subscribe();
              this.subs.push(deleteSub);
            }
          }

          this.initBundledPayments();
          this.services = this.services.filter(
            (service) => service.uuid !== bundledCost.uuid,
          );
          const updateCharterSub = this.charterDao
            .updateFromPartial(this.charter.id, {
              serviceTotal: this.charter.serviceTotal,
              additionalCosts: this.additionalCosts,
              services: this.services,
            })
            .subscribe();
          this.subs.push(updateCharterSub);
          this.discountServiceTotal = getCharterDiscountServiceTotal(
            this.charter,
          );
        }
      });
    this.subs.push(chickenTestSub);
  }

  removeOtherPayment(otherPayment: Payment) {
    let otherDepositOrFullRemoved = false;

    this.chickenTestDialog
      .open(
        `Are you sure you would like to remove 'other' payment "${otherPayment.name}" for $${otherPayment.amount}?`,
        'Remove',
        'Cancel',
      )
      .subscribe((response) => {
        if (response) {
          if (!this.paymentIsDepositRemainingOrFull(otherPayment)) {
            this.otherPaymentsTotalAmount -= parseFloat(otherPayment.amount);
          }
          otherPayment.failed = true;
          this.paymentDAO
            .getPaymentWithPayouts(otherPayment.id)
            .subscribe((paymentWithPayouts) => {
              const obs = [];
              if (paymentWithPayouts && paymentWithPayouts.payouts) {
                paymentWithPayouts.payouts.forEach((payout) => {
                  this.charter.payouts = this.charter.payouts.filter(
                    (charterPayout) => charterPayout.id !== payout.id,
                  );
                  obs.push(this.payoutDao.deleteMultiple([payout.id]));
                });
                const deleteSub = combineLatest(obs).subscribe((completed) => {
                  console.log(completed);
                });
                this.subs.push(deleteSub);
              }
            });

          if (otherPayment.type === PaymentType.DEPOSIT) {
            this.depositRequestSent = false;
            this.depositSaved = false;
            otherDepositOrFullRemoved = true;
          }
          if (otherPayment.type === PaymentType.FULL) {
            this.fullPaymentRequestSent = false;
            otherDepositOrFullRemoved = true;
          }
          this.miscPayments = this.miscPayments.filter(
            (payment) => otherPayment.id !== payment.id,
          );
          this.services = this.services.filter((service) => {
            if (!service.paymentId || service.paymentId !== otherPayment.id) {
              return true;
            }
            return false;
          });
          this.additionalCosts.additionalCharges.individualCosts =
            this.additionalCosts.additionalCharges.individualCosts.filter(
              (cost) => {
                if (
                  cost.type !== 'other' ||
                  cost.paymentId !== otherPayment.id
                ) {
                  return true;
                }
                return false;
              },
            );
          const updateCharterSub = this.charterDao
            .updateFromPartial(this.charter.id, {
              serviceTotal: this.charter.serviceTotal,
              additionalCosts: this.additionalCosts,
              services: this.services,
            })
            .subscribe(() => {
              const updatePaymentSub = this.paymentDAO
                .updateFromPartial(otherPayment.id, otherPayment)
                .subscribe(() => {
                  if (otherDepositOrFullRemoved) {
                    this.runInvoiceInit.next(true);
                  }
                });
              this.subs.push(updatePaymentSub);
            });
          this.subs.push(updateCharterSub);
          this.discountServiceTotal = getCharterDiscountServiceTotal(
            this.charter,
          );
        }
      });
  }

  onTabChange(event: MatTabChangeEvent) {
    this.router
      .navigate(['.'], {
        relativeTo: this.route,
        queryParams: { index: event.index, noScroll: true },
        queryParamsHandling: 'merge',
      })
      .catch((mergeQueryParamError) => {
        console.error(mergeQueryParamError);
      });
  }

  updateCharterAdditionalCostsFromReconTab($event: AdditionalCosts) {
    this.charter.additionalCosts = $event;
    this.additionalCosts = $event;
  }

  updateCharterPaymentsFromInvoicing($event: Payment[]) {
    this.payments = $event;
    this.initPayments();
    this.initOtherPayments();
    this.initPaymentsWithPayouts();
    this.initBundledPayments();
  }

  onExpandChange(event: boolean): void {
    this.router.navigate(['manage', 'manage-charter', this.charter.id], {
      queryParams: {
        collapsed: event ? '0' : '1',
      },
      queryParamsHandling: 'merge',
    });
  }

  onRefundSuccess(): void {
    const refundedPayment = this.currentRefundPayment;
    refundedPayment.refunded = true;
    let partialCharterForRefundSuccessUpdate: Partial<Charter>;
    if (this.paymentIsDepositRemainingOrFull(refundedPayment)) {
      this.filterAddCostsOnRefundSuccess(refundedPayment);
      partialCharterForRefundSuccessUpdate = {
        additionalCosts: this.additionalCosts,
      };
    } else {
      this.filterMiscOnRefundSuccess(refundedPayment);
      this.filterServicesOnRefundSuccess(refundedPayment);
      this.filterAddCostsOnRefundSuccess(refundedPayment);
      this.filterPayoutsOnRefundSuccess(refundedPayment);
      this.charter.serviceTotal -= Number(refundedPayment.amount);
      partialCharterForRefundSuccessUpdate = {
        serviceTotal: this.charter.serviceTotal,
        additionalCosts: this.additionalCosts,
        services: this.services,
      };
    }

    const updateCharterSub = this.charterDao
      .updateFromPartial(this.charter.id, partialCharterForRefundSuccessUpdate)
      .subscribe((completed) => {
        this.openSnackbar('Success! The refund has been processed.');
      });
    this.subs.push(updateCharterSub);
  }

  private readQueryParams(): void {
    this.queryParamIndex = parseInt(
      this.route.snapshot.queryParamMap.get('index'),
      10,
    );
    this.collapseCharterInfo =
      this.route.snapshot.queryParamMap.get('collapsed') === '1';
    if (this.route.snapshot.queryParamMap.get('runFuelAddHours') === '1') {
      this.runFuelAndAddHoursCalc.next(true);
    }
  }

  private paymentIsDepositRemainingOrFull(payment: Payment): boolean {
    const types = [
      PaymentType.DEPOSIT,
      PaymentType.FULL,
      PaymentType.REMAINING,
    ];
    return types.includes(payment.type);
  }

  private filterMiscOnRefundSuccess(refundedPayment: Payment): void {
    this.miscPayments = this.miscPayments.filter(
      (miscPayment) => miscPayment.id !== refundedPayment.id,
    );
  }

  private filterServicesOnRefundSuccess(refundedPayment: Payment): void {
    this.services = this.services.filter((service) => {
      if (!service.paymentId || service.paymentId !== refundedPayment.id) {
        return true;
      }
      // Subtract service cost from charter total
      this.otherPaymentsTotalAmount -= Number(refundedPayment.amount);
      return false;
    });
  }

  private filterAddCostsOnRefundSuccess(refundedPayment: Payment): void {
    this.additionalCosts.additionalCharges.individualCosts =
      this.additionalCosts.additionalCharges.individualCosts.filter((cost) => {
        if (cost.paymentId !== refundedPayment.id) {
          return true;
        }
        return false;
      });
  }

  private filterPayoutsOnRefundSuccess(refundedPayment: Payment): void {
    this.charter.payouts = this.charter.payouts.filter((cost) => {
      // @ts-ignore
      if (cost.paymentId !== refundedPayment.id) {
        return true;
      }
      return false;
    });
  }

  private initAvailableAtAnotherTimeCheck() {
    const altTimeReqSub = this.charterAlternateTimeRequestDAO
      .getAllCharterAlternateTimes(this.charterId, this.charter.boat.id)
      .subscribe((altTimeRequest) => {
        this.alternateTimeRequest = altTimeRequest;
      });
    this.subs.push(altTimeReqSub);
  }

  private initPromoCodeCheck() {
    this.boatCaptCrewTotal = getBoatCaptCrewTotalFromOriginalRates(
      this.charter.originalRates,
      this.getDurationType(this.charter.duration),
      0,
    );
    if (
      this.charter.pricingMetaData &&
      this.charter.pricingMetaData.promoCode &&
      this.charter.pricingMetaData.promoCode.code
    ) {
      this.promoCode = this.charter.pricingMetaData.promoCode;
      this.promoCodeApplied = true;
    }
  }

  syncGigsForCharter(): void {
    this.captainGigDAO
      .syncGigsForCharterEdit(this.charter.id, this.charter.vesselId)
      .subscribe((gigSync) => {
        this.openSnackbar('Captain gigs updated');
      });
  }

  openAddPromoModal() {
    if (this.charter.remainderStatus !== ConstantMan.PAYMENT_STATUS.PAID) {
      const config: MatDialogConfig = {
        maxWidth: '355px',
        data: {
          boatCaptCrewTotal: this.boatCaptCrewTotal,
          affiliateId: this.charter.affiliateId,
        },
      };

      const promoDialogSub = this.dialog
        .open(AdminPromoCodeComponent, config)
        .afterClosed()
        .subscribe((data) => {
          if (data && data.promoResponse && data.promoResponse.discountId) {
            const discountSub = this.discountDAO
              .getById(data.promoResponse.discountId)
              .subscribe((discount) => {
                this.charter.affiliateId = null;
                this.promoCode = {
                  ...discount,
                  promoDiscountAmount: data.discountTotal,
                };
                this.addPromoCodeToPricingMetaData();
                this.removeCharterAgreementInformation();
                this.promoCodeApplied = true;
                this.discountServiceTotal = getCharterDiscountServiceTotal(
                  this.charter,
                );
                const charterUpdateSub = this.charterDao
                  .updateCharter(this.charter)
                  .subscribe((completed) => {
                    this.refreshAffiliateInfo.next(true);
                  });
                this.subs.push(charterUpdateSub);
              });
            this.subs.push(discountSub);
          }
        });

      this.subs.push(promoDialogSub);
    }
  }

  openRemovePromoModal() {
    if (this.charter.remainderStatus !== ConstantMan.PAYMENT_STATUS.PAID) {
      const config: MatDialogConfig = {
        maxWidth: '355px',
        data: { promoCode: this.promoCode },
      };
      const promoDialogSub = this.dialog
        .open(AdminPromoCodeComponent, config)
        .afterClosed()
        .subscribe((data) => {
          if (data && data.removePromo) {
            this.promoCodeApplied = false;
            this.promoCode = null;
            delete this.charter.pricingMetaData.promoCode;
            this.discountServiceTotal = getCharterDiscountServiceTotal(
              this.charter,
            );
            this.removeCharterAgreementInformation();
            const charterUpdateSub = this.charterDao
              .updateCharter(this.charter)
              .subscribe();
            this.subs.push(charterUpdateSub);
          }
        });

      this.subs.push(promoDialogSub);
    }
  }

  private addPromoCodeToPricingMetaData() {
    if (this.charter.pricingMetaData) {
      this.charter.pricingMetaData.promoCode = this.promoCode;
    } else {
      this.charter.pricingMetaData = {
        promoCode: this.promoCode,
      };
    }
  }

  private removeCharterAgreementInformation() {
    this.charter.agreementCreatedDate = null;
    this.charter.agreementSignedDate = null;
    this.charter.agreementUrl = null;
    this.charter.signedAgreementUrl = null;
  }

  updateCharterFromInvoicing(charter: Charter) {
    this.charter = charter;
    if (this.charter.pricingMetaData.addOns?.length > 0) {
      this.charter.pricingMetaData.addOns =
        this.charter.pricingMetaData.addOns.map((x) => ({
          ...x,
          markupPrice: getAddOnCost(x, true),
        }));
    }
  }

  goToStripePaymentIntent(paymentIntentId: string) {
    if (paymentIntentId.includes('pi_')) {
      let stripeUrl = `https://dashboard.stripe.com/payments/${paymentIntentId}`;
      if (!environment.production) {
        stripeUrl = `https://dashboard.stripe.com/test/payments/${paymentIntentId}`;
      }
      window.open(stripeUrl, '_blank');
    }
  }

  updateOfferNoteDisplay(status) {
    const updatedOffers = this.charter.offers.map((offer) => ({
      ...offer,
      displayNote: status,
    }));

    this.offerDAO.updateOffers(updatedOffers).subscribe((response) => {
      this.charter.offers = response;
    });
  }

  viewCustomOfferPayouts(offerIdx) {
    const offer = this.charter.offers[offerIdx];
    this.customOfferPayoutsDialogService.open(
      this.charter,
      `Payout breakdown - special offer ${offerIdx + 1}`,
      this.getVesselPricing(
        offer.customOriginalRates || this.charter.originalRates,
      ),
      this.charter.duration,
      this.charter.offers[offerIdx].vesselId,
      offer.customOriginalRates,
      offer.customAddOns,
      true,
    );
  }

  getVesselPricing(rates: VesselRate[]): number {
    const standardRates = rates.filter(
      (x) => ![RateType.BookingFee].includes(x.rateType),
    );

    const standardTotalHourlyRate = this.calculateStandardRateTotals(
      standardRates,
      this.charter.duration,
    );

    const bookingRate = rates.find((x) => x.rateType === RateType.BookingFee);
    const bookingFee =
      standardTotalHourlyRate *
      this.charter.duration *
      bookingRate.percentageBasedRatePercent;

    return standardTotalHourlyRate * this.charter.duration + bookingFee;
  }

  calculateStandardRateTotals(rates, duration) {
    let standardTotalHourlyRate = 0;

    rates.map((rate) => {
      if (
        rate.rateType === RateType.Custom ||
        rate.rateType === RateType.Cleaning
      ) {
        standardTotalHourlyRate +=
          (rate.customRate *
            (1 + rate.markupPercentage) *
            (1 + rate.taxPercentage)) /
          duration;
      } else {
        standardTotalHourlyRate +=
          rate.hourlyRate *
          (1 + rate.markupPercentage) *
          (1 + rate.taxPercentage);
      }
    });

    return standardTotalHourlyRate;
  }
}

export function addNewLines(text) {
  if (text) {
    return text.replace(/<br ?\/?>/g, '\n');
  } else {
    return '';
  }
}

export function getCharterDiscountServiceTotal(charter: Charter): number {
  const manualTransactionCost =
    charter.additionalCosts?.additionalCharges.individualCosts.reduce(
      (acc, cost) => {
        if (cost.type !== 'other') {
          return acc + parseFloat(cost.total) || 0;
        }
        return acc;
      },
      0,
    ) || 0;

  let total =
    charter.charterBaseFee +
    manualTransactionCost +
    getAddOnsTotalFromPricingMetaData(charter.pricingMetaData, null, true) -
    charter.discountTotal;
  if (charter.pricingMetaData && charter.pricingMetaData.promoCode) {
    total -= charter.pricingMetaData.promoCode.promoDiscountAmount;
  }
  return total;
}

export function getLastPaymentType(
  charter: Charter,
  paymentType: PaymentType,
): Payment {
  let returnPayment = null;
  if (charter && charter.payments) {
    charter.payments.forEach((payment) => {
      if (payment.type === paymentType) {
        returnPayment = payment;
      }
    });
  }
  return returnPayment;
}

export function parseJson(json: string): any {
  // todo remove and replace with this.numFormatter
  // let isString = true;
  let el = json as any;
  let isString = typeof el === 'string';
  while (isString) {
    el = JSON.parse(el);
    if (typeof el !== 'string') {
      isString = false;
    }
  }
  return el;
}

export interface TransactionData {
  amount: string;
  userId?: number;
  description: string;
  name: string;
  charterId: number;
  customerPaymentMethod?: any;
  remainderStatus: string;
  paid?: boolean;
  failed?: boolean;
  manual?: boolean;
  type?: string;
  notes?: string;
  transId?: string;
  clonePreviousPayment?: boolean;
  payoutInfo?: PayoutInfo;
  paymentMethodNonce?: string;
  transactions?: PaymentIntent;
}
